module.exports = __webpack_public_path__ + "img/gas.be9f838d.png";